import InspectorManager from '@/toolbar/inspector/InspectorManager'

export const initInspector = locator => {
  const { isUnitaryTest } = locator.$store.state
  if (isUnitaryTest) return

  locator.inspector = new InspectorManager(locator)
  locator.inspector.inspect(['700-799'])
}
